<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-auto_fill_from_track'"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("select release")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <SearchList
          :id="'release'"
          :items="items"
          :keyProperty="'release_id'"
          :label="'release_artist'"
          :placeholder="'Search release'"
          :isSearchable="false"
          @selected="onReleaseSelected"
        >
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row">
              <dt
                class="dt-table2--column"
                style="border-right:1px solid #fefefe"
              >
                <div class="ut-flex">
                  <div style="flex:0.2" class="checkbox-container">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        name="name"
                        :checked="selectedReleases.has(item.release_id)"
                        @click="e => onCheckboxChange(e, 'name', item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div style="flex:0.8" class="txtov">
                    {{ item.release_artist }}
                  </div>
                </div>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{ item.release_title }}</span>
              </dt>
            </tr>
          </template>
        </SearchList>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { Subject } from "rxjs";
import { ContractsService } from "../../services/contracts.service";
import { addRemoveSet } from "../../../../utility";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      unrelatedReleases: [],
      selectedReleases: new Set()
    };
  },
  mounted: async function() {
    const res = await ContractsService.autoFillFromTracks(this.contract_id);
    this.unrelatedReleases = res.data.releases;
  },
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    },
    items: function() {
      return this.unrelatedReleases || [];
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onOkClick: async function() {
      const ids = JSON.stringify(Array.from(this.selectedReleases)); // Convert to Array,  Join -- convert to string

      const res = await ContractsService.saveAutoFill({
        contract_id: this.contract_id,
        ids
      });
      let res1 = await ContractsService.fetchDetailsTabContractsItem(this.contract_id);
      this.$emit("added", res1.data);
    },

    onCheckboxChange: function(event, name, item) {
      
      const value = event.target.checked;
      this.selectedReleases = addRemoveSet(
        event.target.checked,
        this.selectedReleases,
        item.release_id
      );
      console.log(this.selectedReleases,'selectedReleases')
    },
    onReleaseSelected:function(selectedReleases){

      
      this.selectedReleases = selectedReleases;
      console.log(this.selectedReleases,'selectedReleases')
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-auto_fill_from_track {
  .ut-flex {
    .checkbox-container {
      flex: 0.1 !important;
    }

    .txtov {
      flex: 0.9 !important;
    }
  }
}
</style>
